import React from 'react';
import { ScanSearch, ScanText, Atom, Table2, BookText, Search as SearchIcon, Workflow } from 'lucide-react';

export const featureCardData = [
  {
    id: 'extraction',
    icon: <ScanSearch className="h-10 w-10 sm:h-12 sm:w-12 text-sky-400 mb-4 sm:mb-5" strokeWidth={1.5} />,
    title: 'Extraction',
    description: `Our AI algorithms intelligently scan and identify areas of interest on the scanned document
                  with the ability to work with diverse document layouts and formats, from books sitting on shelves
                  to digitised PDFs.`
  }, {
    id: 'ocr',
    icon: <ScanText className="h-10 w-10 sm:h-12 sm:w-12 text-sky-400 mb-4 sm:mb-5" strokeWidth={1.5} />,
    title: 'Character Recognition',
    description: `Many documents aren't written to be easily read, especially archive notebookes, so our state-of-the-art
                  OCR models allow for accurate transcriptions of everything from digitised text to diffult-to-read handwritten notes.`
  }, {
    id: 'ocsr',
    icon: <Atom className="h-10 w-10 sm:h-12 sm:w-12 text-sky-400 mb-4 sm:mb-5" strokeWidth={1.5} />,
    title: 'Chemical Recognition',
    description: `Enourmous amounts of information in chemical documents is trapped within the diagrams of chemical structures themselves,
                  so our specially-trained OCSR models are trained for interpreting molecules using a wide array of notations, ensuring that we
                  can always get the most out of your documents`
  }, {
    id: 'table',
    icon: <Table2 className="h-10 w-10 sm:h-12 sm:w-12 text-sky-400 mb-4 sm:mb-5" strokeWidth={1.5} />,
    title: 'Table Structuring',
    description: `Tables are a critical part of much of research in general, and they are some of the most information-dense elements in most
                  documents. We developed innovative techniques for detecting and structuring tables, ensuring that this information is extracted.`
  }, {
    id: 'structure',
    icon: <BookText className="h-10 w-10 sm:h-12 sm:w-12 text-sky-400 mb-4 sm:mb-5" strokeWidth={1.5} />,
    title: 'Document Structuring',
    description: `We bring together information across all pages in a document to provide a cohesive story of the information in a document. Vital for
                  ensuring that you get the whole context of the data.`
  }, {
    id: 'search',
    icon: <SearchIcon className="h-10 w-10 sm:h-12 sm:w-12 text-sky-400 mb-4 sm:mb-5" strokeWidth={1.5} />,
    title: 'Search',
    description: `Extracted information is useless if it is not searchable. That's why we developed search algorithms to make the most of your unique
                  datasets for your research.`
  }, {
    id: 'format',
    icon: <Workflow className="h-10 w-10 sm:h-12 sm:w-12 text-sky-400 mb-4 sm:mb-5" strokeWidth={1.5} />,
    title: 'Format',
    description: `Our structured data can be integrated with a wide range of electonic lab notebooks, ensuring that your data can be used within the
                  research workflows you're already familiar with.`
  }
];